// firebase-config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase config (replace with your actual config)
const firebaseConfig = {
  apiKey: "AIzaSyAxaze6KyzWLsFkVOolReNHqMa9wKvWtj0",
  authDomain: "firetool-dashboard.firebaseapp.com",
  projectId: "firetool-dashboard",
  storageBucket: "firetool-dashboard.firebasestorage.app",
  messagingSenderId: "246169955494",
  appId: "1:246169955494:web:b01c6aa5c00aba383c1867",
  measurementId: "G-84E63FTNM6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service.
// REACT_APP_FIRESTORE_DB selects a named database (staging); unset uses the default.
const firestoreDbName = process.env.REACT_APP_FIRESTORE_DB;
export const db = firestoreDbName
  ? getFirestore(app, firestoreDbName)
  : getFirestore(app);

console.info(`[firebase] Firestore database: ${firestoreDbName || 'default'}`);

export default app;